import { useSearchParameter } from 'framework/routing';
import { useNavigate } from 'react-router-dom';

export const PARAMS_KEY = 'candidateId';

const useConversionRouteHelper = () => {
  const navigate = useNavigate();
  const candidateId = useSearchParameter(PARAMS_KEY);

  return {
    candidateId,
    setCandidateId: (parameter: any) => {
      if (parameter) {
        navigate({
          search: `?${PARAMS_KEY}=${parameter}`,
        });
      } else {
        navigate({
          search: '',
        });
      }
    },
  };
};

export default useConversionRouteHelper;
